import React from "react";
// import { useTranslation } from "react-i18next";

interface DirectionSelectionModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSelectDirection: (direction: "injection" | "offtake") => void;
  ean: string;
}

export const DirectionSelectionModal: React.FC<DirectionSelectionModalProps> = ({
  isOpen,
  onClose,
  onSelectDirection,
  ean,
}) => {
  // const { t } = useTranslation("addservice");

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black bg-opacity-50" onClick={onClose} />
      <div className="relative bg-white rounded-lg shadow-xl max-w-md w-full mx-4 p-6">
        <div className="text-center mb-6">
          <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-yellow-100 mb-4">
            <svg className="h-6 w-6 text-yellow-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
          </div>
          <h3 className="text-lg font-semibold text-gray-900 mb-2">Select Contract Direction</h3>
          <p className="text-sm text-gray-600 mb-2">
            EAN: <span className="font-medium">{ean}</span>
          </p>
          <p className="text-sm text-gray-600">
            This meter supports both injection and offtake, but requires separate contracts for each direction. Please
            select which contract you'd like to create first.
          </p>
        </div>

        <div className="space-y-3">
          <button
            onClick={() => onSelectDirection("injection")}
            className="w-full flex items-center justify-between p-4 border-2 border-gray-200 rounded-lg hover:border-primary-500 hover:bg-primary-50 transition-all"
          >
            <div className="flex items-center">
              <div className="mr-3">
                <svg className="w-6 h-6 text-primary-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 11l5-5m0 0l5 5m-5-5v12" />
                </svg>
              </div>
              <div className="text-left">
                <p className="font-semibold text-gray-900">Injection Contract</p>
                <p className="text-xs text-gray-500">Create injection contract first</p>
              </div>
            </div>
            <svg className="w-5 h-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </button>

          <button
            onClick={() => onSelectDirection("offtake")}
            className="w-full flex items-center justify-between p-4 border-2 border-gray-200 rounded-lg hover:border-primary-500 hover:bg-primary-50 transition-all"
          >
            <div className="flex items-center">
              <div className="mr-3">
                <svg className="w-6 h-6 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 13l-5 5m0 0l-5-5m5 5V6" />
                </svg>
              </div>
              <div className="text-left">
                <p className="font-semibold text-gray-900">Offtake Contract</p>
                <p className="text-xs text-gray-500">Create offtake contract first</p>
              </div>
            </div>
            <svg className="w-5 h-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </button>
        </div>

        <div className="mt-4 p-3 bg-blue-50 rounded-lg">
          <p className="text-xs text-blue-800">
            <span className="font-semibold">Note:</span> After signing the first contract, you'll be prompted to create
            the second contract for the remaining direction.
          </p>
        </div>

        <button onClick={onClose} className="mt-4 w-full py-2 text-sm text-gray-600 hover:text-gray-800">
          Cancel
        </button>
      </div>
    </div>
  );
};
